import React from 'react';
import styles from './AdModal.module.css';

const AdModal = ({ data }) => {
  return (
    <div className={styles.adModal}>
      <img src={data?.popupImages[0]?.url} alt="Ad background" className={styles.backgroundImageAd} />
      <div className={styles.contentAd}>
        <h2 className={styles.titleAd}>{data?.popupTitle}</h2>
        <div
          className={`${styles.descriptionAd} detail-description`}
          dangerouslySetInnerHTML={{ __html: data?.popupDescription }}
        />
        {data?.popupLink && (
        <a
          href={data?.popupLink}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.buttonAd}
        >
          View More
        </a>
        )}
      </div>
    </div>
  );
};

export default AdModal;